import {
  PERMISSION_REQUEST,
  PERMISSION_SUCCESS,
  PERMISSION_FAIL,
  PERMISSION_CLEAR_ERRORS,
} from "../Constants/permissions_constants";

export const permission_reducer = (
  state = {
    permission: [],
  },
  action
) => {
  switch (action.type) {
    case PERMISSION_REQUEST:
      return {
        permission_loading: true,
        permission: [],
      };
    case PERMISSION_SUCCESS:
      return {
        permission_loading: false,
        permission: action.payload.data,
      };
    case PERMISSION_FAIL:
      return {
        permission_loading: false,
        permission: null,
        permission_error: action.payload,
      };

    case PERMISSION_CLEAR_ERRORS:
      return {
        ...state,
        permission_error: null,
      };
    default:
      return state;
  }
};
